import common from "../../common";
import MiniSignal from "mini-signals";
import ControlMethod from "./ControlMethod";

export default class ControlMethodVirtualStick extends ControlMethod
{
    constructor(fighter, stick)
    {
        super(fighter);

        this.stick = stick;

        this.stickTarget = {x:0, y:0, angle:0, distance:0};

        this.blockedAreas = [
            {
                x: common.STAGE_HALF_WIDTH + (P3.View.width/2) - 300,
                y: 0,
                width: 300,
                height: 300
            },
            {
                x: common.STAGE_HALF_WIDTH + (P3.View.width/2) - 300,
                y: common.STAGE_HEIGHT - 300,
                width: 300,
                height: 300
            }
        ];

        this.init();
    }

    init()
    {
        this.gameScene.signalListeners.push(P3.input.signals.mouseMove.add(this.onMouseMove, this));
        this.gameScene.signalListeners.push(P3.input.signals.mouseDown.add(this.onMouseDown, this));
        this.gameScene.signalListeners.push(P3.input.signals.mouseUp.add(this.onMouseUp, this));
        
        super.init();
    }

    destroy()
    { 
        super.destroy();
    }

    update()
    {
        this.stick.stick.x += (this.stickTarget.x - this.stick.stick.x) / 5;
        this.stick.stick.y += (this.stickTarget.y - this.stick.stick.y) / 5;

        //var distance = Math.min(1, ( Math.sqrt(Math.pow(this.stick.stick.y, 2) + Math.pow(this.stick.stick.x, 2)) ) / (this.stick.base.radius - this.stick.stick.radius));

        this.movement.x = this.stickTarget.x / (this.stick.base.radius - this.stick.stick.radius);//Math.cos(this.stickTarget.angle) * distance;
        this.movement.y = this.stickTarget.y / (this.stick.base.radius - this.stick.stick.radius);//Math.sin(this.stickTarget.angle) * distance;
    }

    isTouchInBlockedArea(x, y)
    {
        for(var i in this.blockedAreas)
        {
            var b = this.blockedAreas[i];
            if(x > b.x &&
               x < b.x + b.width &&
               y > b.y &&
               y < b.y + b.height)
            {
                return true;
            }
        }
        return false;
    }

    onMouseMove(e)
    {
        if(this.gameScene.paused) return;

        var pos = e.data.getLocalPosition(this.gameScene);

        if(this.isTouchInBlockedArea(pos.x, pos.y))
        {
            return;
        }

        pos = e.data.getLocalPosition(this.stick.base);
        this.stickTarget = pos;

        var hyp = Math.sqrt(Math.pow(pos.y, 2) + Math.pow(pos.x, 2));

        this.stickTarget.angle = Math.atan2(pos.y, pos.x);
        if(this.stickTarget.angle < 0) this.stickTarget.angle = (2*Math.PI) + this.stickTarget.angle;

        if(hyp > this.stick.base.radius - this.stick.stick.radius)
        {
            this.stickTarget.x = Math.cos(this.stickTarget.angle) * (this.stick.base.radius - this.stick.stick.radius); 
            this.stickTarget.y = Math.sin(this.stickTarget.angle) * (this.stick.base.radius - this.stick.stick.radius); 
        }
    }

    onMouseDown(e)
    {
        if(this.gameScene.paused) return;

        var pos = e.data.getLocalPosition(this.gameScene);

        if(this.isTouchInBlockedArea(pos.x, pos.y))
        {
            return;
        }

        this.stick.base.x = pos.x;
        this.stick.base.y = pos.y;
        this.stick.base.alpha = 0;
        TweenMax.to(this.stick.base, 0.4, {alpha:1});
    }

    onMouseUp(e)
    {
        if(this.gameScene.paused) return;

        this.stickTarget.x = 0;
        this.stickTarget.y = 0;
    }
}